import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ff691e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-label", "data-ratio"]
const _hoisted_2 = { class: "chips-container" }
const _hoisted_3 = {
  key: 0,
  class: "bet-total-group"
}
const _hoisted_4 = { class: "bet-total" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "svg",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M143,20a10,10,0,1,1,10-10A10,10,0,0,1,143,20Zm2.589-12.854H148.8a5.24,5.24,0,0,0-4.6-4.108V1.6a.8.8,0,0,0-.8-.8h-.8a.8.8,0,0,0-.8.8V2.943c-3.073.335-4.737,1.609-4.954,3.846,0,1.972,1.66,3.367,4.954,4.192v4.186a9.291,9.291,0,0,1-5.311-3.381v2.855a8.835,8.835,0,0,0,5.311,2.59V18.4a.8.8,0,0,0,.8.8h.8a.8.8,0,0,0,.8-.8V17.286c3.524-.175,5.278-1.465,5.225-3.894-.057-2.269-1.812-3.745-5.225-4.445V5.476A2.322,2.322,0,0,1,145.589,7.146ZM140.5,6.789a1.472,1.472,0,0,1,1.3-1.409V8.374C140.9,8.005,140.465,7.479,140.5,6.789Zm5.263,6.6a1.634,1.634,0,0,1-1.567,1.8V11.6C145.287,12.028,145.812,12.624,145.767,13.392Z",
    transform: "translate(-133)",
    fill: "#ffcf7e",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_6 = { class: "bet-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ctrl-bet-box-root", _ctx.betColor]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.placeBet && _ctx.placeBet(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", {
      class: "label-ratio",
      "data-label": _ctx.label,
      "data-ratio": _ctx.ratio
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chipsUI, (chip, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["chip", chip.class]),
          key: index,
          style: _normalizeStyle(`top:var(--pc${chip.y});left:var(--pc${chip.x});`)
        }, _toDisplayString(_ctx.toShortValue(chip.amount)), 7))
      }), 128))
    ]),
    (_ctx.sumOfTempBetandConfirmedBet > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.sumOfTempBetandConfirmedBet), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}